const CONFIG = {
  BASE_URL: 'https://wanderlust-api-ten.vercel.app/',
  DATABASE_NAME: 'wanderlust-db',
  DATABASE_VERSION: 1,
  OBJECT_STORE_NAME: 'wanderlust-object-store',
  // WEBSOCKET_URL: 'wss://wanderlust-api-ten.vercel.app/', // WebSocket URL provided
};

export default CONFIG;
